// import external modules
import React, { Component } from 'react';
import { connect } from 'react-redux';

const PrimaryButton = (props) =>{
    return (
      <button
          className={`btn ${props.styleClass}`}
          onClick={() => props.onClick()}
          disabled={props.disabled}
          {...(props.type && { type: props.type })}
        >
          {/* {!props.disabled ? props.value : } */}
          {props.value}
        </button>
    );
  };

const mapStateToProps = (state) => {
  const {} = state.login;
  return {};
};
export default connect(mapStateToProps, {  })(PrimaryButton);
